// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"21675b1d","827":"f94bd8f0"}[chunkId] + ".chunk.js";
};